let refreshTokenPromise = { refreshing: false };

const tryRefreshToken = async (error, app) => {
  app.$log.debug('Try refresh token', `, url: ${error.config.url}`, `, isRetry: ${error.config.isRetry}`, `, refreshing: ${refreshTokenPromise.refreshing}`);

  if (error.config.isRetry) {
    return Promise.reject(error);
  }

  if (!refreshTokenPromise.refreshing) {
    if (error.config.headers.jwtacc === app.$http.defaults.headers.jwtacc) {
      if (app.$store.state.realm) {
        refreshTokenPromise = app.$store.dispatch('refreshKeycloakToken', error);
      } else {
        refreshTokenPromise = app.$store.dispatch('refreshBackendToken', error);
      }
      refreshTokenPromise.refreshing = true;
    }
  }

  try {
    app.$log.debug('Await refresh token promise', `, url: /${error.config.url}`);
    await refreshTokenPromise;
  } finally {
    refreshTokenPromise.refreshing = false;
  }

  app.$log.debug('Token refreshed, no error', `, url: /${error.config.url}`);

  // If we still logged on - token refreshed, retry request
  if (app.$http.defaults.headers.jwtacc) {
    // 'Token Expired' means pre-request check
    if (error.message === 'Token Expired') {
      return app.$http.defaults.headers.jwtacc;
    }

    error.config.headers.jwtacc = app.$http.defaults.headers.jwtacc;
    error.config.isRetry = true;
    return app.$http.request(error.config);
  }

  app.$log.debug('Final reject of try-refresh-token');
  return Promise.reject(error);
};

export default tryRefreshToken;
